import React, { useState } from "react";
import { ReactComponent as PenNPaper } from "../../assets/analyse/PenNPaper.svg";
import { ReactComponent as Cherry } from "../../assets/analyse/Cherry.svg";
import { ReactComponent as Circle } from "../../assets/analyse/Circle.svg";
import { ReactComponent as Spark } from "../../assets/analyse/Spark.svg";
import { ReactComponent as Truck } from "../../assets/analyse/Truck.svg";
import { ReactComponent as Box } from "../../assets/analyse/Box.svg";
import "react-widgets/styles.css";
import AnalysisStep from "./AnalysisStep";
import "react-toastify/dist/ReactToastify.css";
import LineColumns from "./LineColumns";
import ModificationLine from "./ModificationLine";
import ReduceLineColumns from './ReduceLineColumns';

const ReduceAnalysisLine = ({
  item,
  changable,
  quantity,
  quantityUnit,
  impact,
  impact_factors,
  checked,
  icon,
  width,
  columns,
  step,
  line_index,
  flow_id,
  color,
  is_reduce,
}) => {
  const [modifying, setModifying] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.screenX;
    setScrollPosition(scrollPosition + position);
  };

  var widthvalue = width - 29.5;
  width -= 30;

  function geticon(icon) {
    switch (icon) {
      case "K_Ingredients":
        return <Cherry height={15} />;
      case "K_Cooking":
        return <Cherry height={15} />;
      case "K_Packaging":
        return <Box height={15} fill={"#bdc4cb"} />;
      case "K_Transports":
        return <Truck height={15} fill={"#bdc4cb"} />;
      case "K_Energies":
        return <Spark height={15} fill={"#bdc4cb"} />;
      case "K_Wastes":
        return <Cherry height={15} />;
      case "K_Food_Given":
        return <Cherry height={15} />;
      default:
        return <Circle height={15} />;
    }
  }

  return (
    <>
      {/* {modifying ? (<ModificationLine icon={icon} item={item} data={changable} modifying={modifying} setModifying={setModifying} width={width}/>) : null} */}
      {/* {modifying ? (
        <ModificationLine
          icon={icon}
          item={item}
          data={step > 2 ? changable : changable[flow_id]}
          flow_id={flow_id}
          modifying={modifying}
          setModifying={setModifying}
          width={width}
          step={step}
          line_index={line_index}
          imapct_factors={impact_factors}
          quantity={quantity}
          quantityUnit={quantityUnit}
          columns={columns}
        />
      ) : null} */}
      <div
        className={`h-[40px] w-max flex justify-start ${
          is_reduce ? "" : "ml-[30px] "
        } ${
          modifying != 0
            ? "bg-white border-gray-500 border-[1px] rounded"
            : color
            ? color === "green"
              ? "bg-green-500/25"
              : "bg-yellow-400/25"
            : "bg-[#F8FAFB] border-[#F3F5F7] border-[0.1px]"
        } ${
          color
            ? color === "green"
              ? "hover:bg-green-300/25"
              : "hover:bg-yellow-300/25"
            : "hover:bg-white border-[#F3F5F7] border-[0.1px]"
        }   items-center`}
      >
        <div
          style={{ width: widthvalue }}
          className={
            "w-[" +
            `${width}` +
            "px] h-[40px] flex justify-between items-center"
          }
        >
          <div className="flex ml-[20px]">
            {geticon(icon)}
            <p className="font-Poppins-Regular text-xs">{item}</p>
          </div>
          {changable != null ? (
            <button
              // className="bg-[green] "
              onClick={() => {
                setModifying(!modifying * 1);
              }}
            >
              <PenNPaper height={10} className="mr-[1px]" />
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
};


export default ReduceAnalysisLine;
